import swPaintColors from './swPaintColors';

// Helper function to parse siding value
const parseSidingValue = (val) => {
  if (!val) return { sidingType: "", sidingColor: "", trim: "", size: "", shutters: "", fascia: "", soffit: "", dripEdge: "" };
  const parts = val.split(" | ");
  const [sidingPart, trimPart, sizePart, shuttersPart, fasciaPart, soffitPart, dripEdgePart] = parts;
  const [sidingType, sidingColor] = sidingPart?.split(" - ") || ["", ""];
  return {
    sidingType: sidingType || "",
    sidingColor: sidingColor || "",
    trim: trimPart || "",
    size: sizePart || "",
    shutters: shuttersPart || "",
    fascia: fasciaPart || "",
    soffit: soffitPart || "",
    dripEdge: dripEdgePart || ""
  };
};

const deckOptions = [
  { name: 'Traditional Mahogany', code: '#6A3B2E'},
  { name: 'Shagbark', code: '#9B7A5B' },
  { name: 'Woodbriar', code: '#946C48' },
  { name: 'Cheyenne Red', code: '#8A3C33' },
  { name: 'Shagbark Brown', code: '#5C3A28' },
  { name: 'Buckthorn', code: '#A4703A' },
  { name: 'Yosemite Gold', code: '#C9A156' },
  { name: 'Salem Red', code: '#A04332' },
  { name: 'Canyon', code: '#97573D' },
  { name: 'Mission Brown', code: '#4A3124' },
  { name: 'Sahara', code: '#D6B87A' },
  { name: 'Almond Tree', code: '#C2A77E' },
  { name: 'Rock Rose', code: '#A85E54' },
  { name: 'Ranchero Red', code: '#923D34' },
  { name: 'Spicewood', code: '#875842' },
  { name: 'Cedar', code: '#B76E40' },
  { name: 'Sequoia', code: '#753E31' },
  { name: 'Russet Brown', code: '#6A4633' },
  { name: 'Fawn', code: '#C2A57D' },
  { name: 'Ember', code: '#AA553D' },
  { name: 'Brick', code: '#8E4A3C' },
  { name: 'Cape Cod Red', code: '#8C3E36' },
  { name: 'Pepperidge', code: '#9A5340' },
  { name: 'Desert Wood', code: '#B47A52' },
  { name: 'Monterey Tan', code: '#C9AF8B' },
  { name: 'Shade Tree', code: '#7D775C' },
  { name: 'Acadia Blue', code: '#56788E' },
  { name: 'Lodge Brown', code: '#4F372B' },
  { name: 'Palmetto', code: '#5E6E55' },
  { name: 'Greenbrier', code: '#4E6552' },
  { name: 'Mallard Green', code: '#3E5041' },
  { name: 'Espresso', code: '#3C2F25' },
  { name: 'Belvedere Tan', code: '#C6A57D' },
  { name: 'Cottonwood', code: '#B99872' },
  { name: 'Orchard', code: '#977D5A' },
  { name: 'Pineneedle', code: '#5C715B' },
  { name: 'Cabin Brown', code: '#5A3D2B' },
  { name: 'Sand Castle', code: '#D1B996' },
  { name: 'Lichen', code: '#7A7D6B' },
  { name: 'Blue Spruce', code: '#516A77' },
  { name: 'Pine Cone', code: '#7A5C3D' },
  { name: 'Summerhouse Beige', code: '#D5C0A4' },
  { name: 'Cypress Moss', code: '#767458' },
  { name: 'Wave Crest', code: '#7EA2B4' },
  { name: 'Leather', code: '#5C4636' },
  { name: 'Navajo White', code: '#F3E2C7' },
  { name: 'Mushroom', code: '#A18E76' },
  { name: 'River Rock', code: '#B9A98F' },
  { name: 'Woodland', code: '#665B47' },
  { name: 'Forest Dew', code: '#B3AF98' },
  { name: 'Charcoal', code: '#4D4D4D' },
  { name: 'Caribou', code: '#7C6651' },
  { name: 'Woodsmoke Gray', code: '#9B9488' },
  { name: 'Hudson Gray', code: '#7C7A70' },
  { name: 'King’s Canyon', code: '#6E5840' },
  { name: 'Black Alder', code: '#3A2D23' },
  { name: 'River Birch', code: '#A99374' },
  { name: 'Stone', code: '#8B8578' },
  { name: 'Meadowbrook', code: '#8EA293' },
  { name: 'Driftwood', code: '#9D8C78' },
  { name: 'Misty Mauve', code: '#A98B89' },
  { name: 'Flagstone', code: '#B6ADA0' },
  { name: 'Juniper Blue', code: '#5A7D8C' },
  { name: 'Mercury', code: '#868B8F' },
  { name: 'Tobacco', code: '#6C4A32' },
  { name: 'Wet Clay', code: '#9A7561' },
  { name: 'Chesapeake', code: '#7D8A8D' },
  { name: 'Traditional Stone Hedge', code: '#6E716A' },
  { name: 'Smoke Tree', code: '#975F46' },
  { name: 'Antique Gray', code: '#C1BAB2' },
  { name: 'Shale', code: '#898276' },
  { name: 'Gray Birch', code: '#B6B1A3' },
];

const compositeOptions = [
  { name: 'Good Life - Escapes - Beach House', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/good-escapes-beach-house.jpg' },
  { name: 'Good Life - Escapes - Bungalow', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/good-escapes-bugalow.jpg' },
  { name: 'Good Life - Escapes - Cabana', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/good-escapes-cabana.jpg' },
  { name: 'Good Life - Escapes - Tuscan Villa', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/good-escapes-tuscan-villa.jpg' },
  { name: 'Good Life - Weekender - Cabin', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/good-weekender-cabin.jpg' },
  { name: 'Good Life - Weekender - Cottage', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/good-weekender-cottage.jpg' },
  { name: 'Sanctuary - Chai', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/sanctuary-chai.jpg' },
  { name: 'Sanctuary - Earl Grey', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/sanctuary-earl-grey.jpg' },
  { name: 'Sanctuary - Espresso', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/sanctuary-espresso.jpg' },
  { name: 'Sanctuary - Latte', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/sanctuary-latte.jpg' },
  { name: 'Sanctuary - Moringa', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/sanctuary-moringa.jpg' },
];

//stain options
const stainOptions = [
  { name: 'Antique Jade', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/antique-jade.JPG' },
  { name: 'Antique Walnut', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/antique-walnut.JPG' },
  { name: 'Apple Cider', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/apple-cider.JPG' },
  { name: 'Burgundy', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/burgundy.JPG' },
  { name: 'Charcoal Gray', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/charcoal-gray.JPG' },
  { name: 'Cherry Blossom', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/cherry-blossom.JPG' },
  { name: 'Cinnamon Toast', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/cinnamon-toast.JPG' },
  { name: 'Classic Black', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/classic-black.JPG' },
  { name: 'Coffee', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/coffee.JPG' },
  { name: 'Colonial Pine', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/colonial-pine.JPG' },
  { name: 'Coral', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/coral.JPG' },
  { name: 'Crimson', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/crimson.JPG' },
  { name: 'Daffodil', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/daffodil.JPG' },
  { name: 'Deep Ocean', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/deep-ocean.JPG' },
  { name: 'Desert Sand', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/desert-sand.JPG' },
  { name: 'Driftwood', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/driftwood.JPG' },
  { name: 'Green Tea', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/green-tea.JPG' },
  { name: 'Harvest Gold', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/harvest-gold.JPG' },
  { name: 'Harvest Grain', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/harvest-grain.JPG' },
  { name: 'Honeycomb', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/honeycomb.JPG' },
  { name: 'Honeydew', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/honeydew.JPG' },
  { name: 'Hunter Green', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/hunter-green.JPG' },
  { name: 'Island Water', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/island-water.JPG' },
  { name: 'Natural Beige', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/natural-beige.JPG' },
  { name: 'Natural Peach', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/natural-peach.JPG' },
  { name: 'Navy Blue', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/nevy-blue.JPG' },
  { name: 'Onyx', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/onyx.JPG' },
  { name: 'Pearl Gray', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/pearl-gray.JPG' },
  { name: 'Perfectly Pink', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/perfectly-pink.JPG' },
  { name: 'Pure White', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/pure-white.JPG' },
  { name: 'Rosewood', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/rosewood.jpg' },
  { name: 'Sangria', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/sangria.JPG' },
  { name: 'Slate', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/slate.JPG' },
  { name: 'Slate Blue', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/slate-blue.JPG' },
  { name: 'Spice', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/spice.JPG' },
  { name: 'Tangerine', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/tangerine.JPG' },
  { name: 'Terracotta', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/terracotta.JPG' },
  { name: 'Toffee', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/toffee.JPG' },
  { name: 'Vermont Maple', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/vermont-maple.JPG' },
  { name: 'White Frost', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/white-frost.JPG' },
  { name: 'Woodrose', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-stains/woodrose.JPG' },
];

// Siding options data
const sidingOptions = [
  {
    name: "Double 4 Siding",
    colors: [
      { name: "White", code: "#FFFFFF" },
      { name: "Cream", code: "#F5F5DC" },
      { name: "Beige", code: "#D4C5B9" },
      { name: "Light Gray", code: "#D3D3D3" },
      { name: "Medium Gray", code: "#A9A9A9" },
      { name: "Charcoal", code: "#4A4A4A" },
      { name: "Navy Blue", code: "#1C3A5C" },
      { name: "Slate Blue", code: "#6A7B8C" },
      { name: "Sage Green", code: "#B2C2A3" },
      { name: "Forest Green", code: "#3B5F4A" },
      { name: "Light Brown", code: "#C8A882" },
      { name: "Dark Brown", code: "#5D4E37" },
      { name: "Clay", code: "#B97A57" },
      { name: "Terracotta", code: "#C76846" },
      { name: "Sandstone", code: "#D4AF88" },
    ]
  },
  {
    name: "Shake Siding",
    colors: [
      { name: "White", code: "#FFFFFF" },
      { name: "Pearl", code: "#F7F3ED" },
      { name: "Cream", code: "#F5F5DC" },
      { name: "Almond", code: "#EFD9C1" },
      { name: "Sandstone", code: "#D4C5B0" },
      { name: "Clay", code: "#C8A882" },
      { name: "Adobe", code: "#B89968" },
      { name: "Sagebrush", code: "#A8A88A" },
      { name: "Gray", code: "#BEBEBE" },
      { name: "Pewter", code: "#A5A5A5" },
      { name: "Slate", code: "#6F7578" },
      { name: "Charcoal", code: "#54585A" },
      { name: "Weathered Cedar", code: "#9B8B7E" },
      { name: "Natural Cedar", code: "#8B7355" },
      { name: "Rustic Red Cedar", code: "#7A5647" },
      { name: "Deep Granite", code: "#4A4A4A" },
    ]
  },
  {
    name: "Board and Batten Siding",
    colors: [
      { name: "White", code: "#FFFFFF" },
      { name: "Linen", code: "#F5F0E8" },
      { name: "Champagne", code: "#E8DCC8" },
      { name: "Sand", code: "#D9C6A8" },
      { name: "Pewter", code: "#B8B5B0" },
      { name: "Sterling", code: "#A5A5A5" },
      { name: "Slate Gray", code: "#6F7578" },
      { name: "Graphite", code: "#4A4A4A" },
      { name: "Midnight Blue", code: "#2B3E50" },
      { name: "Harbor Blue", code: "#4A6B7C" },
      { name: "Storm Blue", code: "#5C7A8C" },
      { name: "Sage", code: "#9BAA8F" },
      { name: "Olive Green", code: "#6B7456" },
      { name: "Forest", code: "#3B4F3A" },
      { name: "Clay", code: "#B5855A" },
      { name: "Cedar", code: "#8B6F47" },
      { name: "Walnut", code: "#6B5444" },
      { name: "Barn Red", code: "#7C3C33" },
    ]
  },
];

// Helper function to get siding color code
const getSidingColorCode = (sidingType, colorName) => {
  if (!sidingType || !colorName) return null;
  const siding = sidingOptions.find(s => s.name === sidingType);
  if (!siding) return null;
  const color = siding.colors.find(c => c.name === colorName);
  return color?.code || null;
};

// Helper function to get deck color code
const getDeckColorCode = (colorName) => {
  if ( !colorName) return null;
  const color = deckOptions.find(c => c.name === colorName);
  return color?.code || null;
};

const getDeckImage = (optionName) => {
  if (!optionName) return null;
  const composite = compositeOptions.find(c => c.name === optionName);
  return composite?.image || null;
};

const getStainImage = (optionName) => {
  if (!optionName) return null;
  const stain = stainOptions.find(c => c.name === optionName);
  return stain?.image || null;
};

// Aluminum railing style options
const aluminumRailingStyleOptions = [
  { name: 'Verticable', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/railing/verticable.jpg' },
  { name: 'Straight', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/railing/straight.jpg' },
];

// Aluminum railing color options
const aluminumRailingColorOptions = [
  { name: 'Black Fine Texture', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Black-Fine-Texture.jpg' },
  { name: 'Bronze Fine Texture', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Bronze-Fine-Texture.jpg' },
  { name: 'Brown Fine Texture', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Brown-Fine-Texture.jpg' },
  { name: 'Chocolate', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Chocolate.jpg' },
  { name: 'Gloss Beige', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Gloss-Beige.jpg' },
  { name: 'Gloss White', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Gloss-White.jpg' },
  { name: 'Grey Fine Texture', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Grey-Fine-Texture.jpg' },
  { name: 'Ninety Bronze', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Ninety-Bronze.jpg' },
  { name: 'Sandy Shore', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Sandy-Shore.jpg' },
  { name: 'Satin Black', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Satin-Black.jpg' },
  { name: 'Speckled Walnut', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/Speckled-Walnut.jpg' },
  { name: 'White Fine Texture', image: 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/decking/colors/White-Fine-Texture.jpg' },
];

// Helper function to get aluminum railing style image
const getAluminumRailingStyleImage = (styleName) => {
  if (!styleName) return null;
  const style = aluminumRailingStyleOptions.find(s => s.name === styleName);
  return style?.image || null;
};

// Helper function to get aluminum railing color image
const getAluminumRailingColorImage = (colorName) => {
  if (!colorName) return null;
  const color = aluminumRailingColorOptions.find(c => c.name === colorName);
  return color?.image || null;
};

// Helper function to get rail color code
const getRailColorCode = (colorName) => {
  if ( !colorName) return null;
  const color = swPaintColors.find(c => c.name === colorName);
  return color?.code || null;
};

// Get image URLs for selections
const getImageUrl = (category, value) => {
  const imageMap = {
    gableOptions: {
      'R': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/gable/Gabel-R.jpg',
      'RT': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/gable/Gabel-RT.jpg',
      'S': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/gable/Gabel-S.jpg',
      'ST': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/gable/Gabel-ST.jpg',
      'RL': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/gable/Gabel-RL.jpg',
      'RTL': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/gable/RTL.jpg',
      'SL': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/gable/Gabel-SL.jpg',
      'STL': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/gable/Gabel-STL.jpg',
    },
    corbelOptions: {
      'C1': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/corbel/Corbel-C1.jpg',
      'C2': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/corbel/Corbel-C2.jpg',
      'CD 4': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/corbel/Corbel-CD-4.jpg',
      'CD 5': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/corbel/Corbel-CD-5.jpg',
      'CD 6': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/corbel/Corbel-CD-6.jpg',
      'R': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/corbel/Corbel-R.jpg',
      'RC': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/corbel/Corbel-RC.jpg',
    },
    shingleColorOptions: {
      'Brownwood': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/brownwood.JPG',
      'Chateau Green': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/chateau-green.jpg',
      'Colonial State': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/colonial-state.jpg',
      'Desert Rose': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/desert-rose.jpg',
      'Driftwood':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/driftwood.jpg',
      'Estate Gray': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/estate-grey.jpg',
      'Midnight Plum': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/midnight-plum.JPG',
      'Onyx Black': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/onyx-black.jpg',
      'Peppercorn': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/peppercorn.jpg',
      'Sand Castle': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/sand-castle.jpg',
      'Sierra Gray': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/sierra-gray.jpg',
      'Slatestone Gray': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/slatestone-grey.jpg',
      'Teak': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/teak.jpg',
      'Terracotta': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/terra-cotta.jpg',
      'Williamsburg Gray': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/shingle-color/williamsburg-gray.JPG',
    },
    kitchenCabinet: {
      'Cape':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveCape.png',
      'Chateau':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveChateau.png',
      'Currant':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveCurrant.png',
      'Evergreen':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveEvergreen.png',
      'Goldleaf':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveGoldleaf.png',
      'Sandalwood':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveSandalwood.png',
      'Silhouette':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveSilhouette.png',
      'Terrain':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GrovTerr.png',
      'Bayside':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveBayside.png',
      'Biscayne':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveBiscayne.png',
      'Juniper':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveJuniper.png',
      'Laurel':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveLaurel.png',
      'Midnight':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveMidnight.png',
      'Palmetto':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GrovePalmetto.png',
      'Pewter':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/grove-pewter.png',
      'Seabreeze':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveSeabreeze.png',
      'Seaport':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveSeaport.png',
      'Stonybrook':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GroveStonybrook.png',
      'Opal':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GrovOpal.png',
      'White':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-cabinets/GrovWhit.png'
    },
    mirrorOptions: {
      'Black': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/mirror/delta-black.jpg',
      'Grey': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/mirror/delta-grey.jpg',
      'Silver': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/mirror/delta-silver.jpg',
      'White': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/mirror/delta-white.jpg',
    },
    kitchenSink: {
      'Sink 1': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink1.jpg',
      'Sink 2': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink2.jpg',
      'Sink 3': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink3.jpg',
      'Sink 4': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink4.jpg',
      'Sink 5': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink5.jpg',
      'Sink 6': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink6.jpg',
      'Sink 7': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink7.jpg',
      'Sink 8': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink8.jpg',
      'Sink 9': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink9.jpg',
      'Sink 10': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink10.jpg',
      'Sink 11': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink11.jpg',
      'Sink 12': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink12.jpg',
    },
    kitchenFaucet: {
      'Bronze Pull Down Faucet': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-faucet/bronze-pull-down.PNG',
      'Bronze Pull Down Faucet with Touch20': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-faucet/bronze-pull-down-touch-20.PNG',
      'Black Pull Down Faucet': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-faucet/black-pull-down.PNG',
    },
    doorOptions: {
      'Caiman':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/caiman.jpg',
      'Carrara': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/carrara.jpg',
      'Colonist': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/colonist.jpg',
      'Craftsman': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/craftsman.jpg',
      'Rockport': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/rockport.jpg',
      'Sante Fe': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/santa-fe.jpg',
      'Smooth Colonist': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/smooth-colonist.jpg',
      '5 Lite Clear': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/5-lite-glass.jpg',
      '1 Lite Clear': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/1-lite-glass.jpg',
      '1 Lite Frosted': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/1-lite-frosted-glass.jpg',
      '10 Lite Clear': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/10-lite-glass.jpg',
      '15 Lite Clear': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/15-lite-glass.jpg',
      '9 Lite Clear': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/9-lite-clear.jpg',
      '1 Lite Pantry': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/1-lite-pantry.jpg',
      '3 Lite Frosted': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/3-lite-frosted.jpg',
      '5 Lite Frosted': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/interior-door/5-lite-frosted.jpg',
    },
    outdoorDoorOptions: {
      'Smooth Star':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door/smooth-star.JPG',
      'High Definition': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door/high-definition.JPG',
      'Traditions': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door/traditions.JPG',
    },
    outdoorDoorGlassOptions: {
      'Chinchilla':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-glass/chinchilla.JPG',
      'Chord': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-glass/chord.JPG',
      'Granite': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-glass/granite.JPG',
      'Rainglass': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-glass/rainglass.JPG',
      'Reeded': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-glass/reeded.JPG',
      'Satin Etched': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-glass/satin-etched.JPG',
    },
    doorHingeOptions: {
      'Black': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/hinge/black-hinge.jpg',
      'Bronze': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/hinge/bronze-hinge.jpg',
      'Brown': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/hinge/brown-hinge.jpg',
      'Chrome': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/hinge/chrome-hinge.jpg',
      'Gold': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/hinge/gold-hinge.jpg',
      'Nickel': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/hinge/nickel-hinge.jpg',
      'Silver': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/hinge/silver-hinge.jpg',
    },
    baseOptions: {
      'L635A':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/L635A.JPG',
      'L724B':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/L724B.JPG',
      '87636':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/87636.JPG',
      '0L634':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0L634.JPG',
      '0L724':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0L724.JPG',
      '07634':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/07634.JPG',
      'LA433':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/LA433.JPG',
      '07623':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/07623.JPG',
      '0W623':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0W623.JPG',
      '0W713':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0W713.JPG',
      '72135':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/72135.JPG',
      '05093':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/05093.JPG',
      '87637':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/87637.JPG',
      '0L723':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0L723.JPG',
      '03102':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/03102.JPG',
      '0L633':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0L633.JPG',
      'L633A':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/L633A.JPG',
      '07113':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/07113.JPG',
      '0W663':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0W663.JPG',
      '03094':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/03094.JPG',
      '0W662':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0W662.JPG',
      '08667':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/08667.JPG',
      '03098':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/03098.JPG',
      '87618':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/87618.JPG',
      '92132':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/92132.JPG',
      'L620A':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/L620A.JPG',
      '00LK4':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/00LK4.JPG',
      '92134':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/92134.JPG',
      '92136':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/92136.JPG',
      '05094':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/05094.JPG',
      '05104':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/05104.JPG',
      '0L430':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0L430.JPG',
      '0W620':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0W620.JPG',
      '5708A':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0708A.JPG',
      '72136':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/72136.JPG',
      'CR684':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/CR684.JPG',
      'WB629':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/WB629.JPG',
      '05709':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/05709.JPG',
      '87628':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/87628.JPG',
      '92133':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/92133.JPG',
      '5204A':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/5204A.JPG',
      '1236B':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/1236B.JPG',
      '01236':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/01236.JPG',
      '0W618':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0W618.JPG',
      'GM022':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/GM022.JPG',
      'LW647':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/LW647.JPG',
      'WM658':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/WM658.JPG',
      '0E163':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/0E163.JPG',
      '72137':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/72137.JPG',
      '92137':'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/baseboards/92137.JPG',
    },
    casingOptions:{
      'L366A': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/L366A.JPG',
      'L356D': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/L356D.JPG',
      '0L324': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0L324.JPG',
      '0W473': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/OW473.JPG',
      '07356': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/07356.JPG',
      '07327': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/07327.JPG',
      '0W316': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0W316.JPG',
      '0W327': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0W327.JPG',
      '0W366': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0W366.JPG',
      '0W356': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0W356.JPG',
      '08581': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/08581.JPG',
      '07366': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/07366.JPG',
      'L332A': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/L332A.JPG',
      'WM321': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/WM321.JPG',
      'WM324': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/WM324.JPG',
      'WM332': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/WM332.JPG',
      '0W453': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0W453.JPG',
      '7453C': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/7453C.JPG',
      '05092': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/05092.JPG',
      'D356A': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/D356A.JPG',
      'L492A': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/L492A.JPG',
      '87362': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/87362.JPG',
      '07351': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/07351.JPG',
      '90472': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/90472.JPG',
      '07361': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/07361.JPG',
      '0W351': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0W351.JPG',
      '08587': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/08587.JPG',
      '278CC': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/278CC.JPG',
      '80644': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/80644.JPG',
      '07714': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/07714.JPG',
      '08583': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/08583.JPG',
      '0W433': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0W433.JPG',
      '07445': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/07445.JPG',
      '00LK1': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/00LK1.JPG',
      '02488': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/02488.JPG',
      '93285': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/93285.JPG',
      'DP380': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/DP380.JPG',
      '0P380': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0P380.JPG',
      '84424': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/84424.JPG',
      '7444A': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/7444A.JPG',
      '0L444': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0L444.JPG',
      '0W360': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0W360.JPG',
      '0W445': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/0W445.JPG',
      '08648': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/casing/08648.JPG',
    },
    ceilingFanOptions:{
      'Dark': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/fan/ceiling-fan-brown.jpg',
      'Light': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/fan/ceiling-fan-wood.jpg',
    },
    garageDoorStyleOptions:{
      'Short Elegant': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/garage-doors/short-elegant.JPG',
      'Short Traditional': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/garage-doors/short-traditional.JPG',
      'Long Elegant': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/garage-doors/long-elegant.JPG',
      'Long Traditional': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/garage-doors/long-traditional.JPG',
    },
    windowOptions:{
      'Double Hung': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/windows/double-hung.png',
      'Casement': 'https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/windows/casement.png',
    },
    fasciaOptions:{
      "Black": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Black.jpg",
      "Brown": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Brown.jpg",
      "Champagne": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Champangne.jpg",
      "Clay": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Clay.jpg",
      "Cottage Red": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Cottage_Red.jpg",
      "Cozy Cottage": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Cozy_Cottage.jpg",
      "Desert Tan": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Desert_Tan.jpg",
      "Eggshell": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/Eggshell.jpg",
      "White": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/siding/fascia-colors/White.jpg",
    },
    exteriorDoorColorOptions:{
      "Acorn": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/acorn.JPG",
      "Alpine": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/alpine.JPG",
      "Arctic Ice": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/arctic-ice.JPG",
      "Autumn Harvest": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/autumn-harvest.JPG",
      "Barley": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/barley.JPG",
      "Cabernet": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/cabernet.JPG",
      "Canyon": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/canyon.JPG",
      "Chestnut": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/chestnut.JPG",
      "Cypress": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/cypress.JPG",
      "Driftwood": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/driftwood.JPG",
      "Elk": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/elk.JPG",
      "Estuary": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/estuary.JPG",
      "Golden Wheat": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/golden-wheat.JPG",
      "Granite": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/granite.JPG",
      "Indigo": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/indigo.JPG",
      "Mulberry": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/mulberry.JPG",
      "New Earth": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/new-earth.JPG",
      "Obsidian": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/obsidian.JPG",
      "Onyx": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/onyx.JPG",
      "Peregrine": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/peragrine.JPG",
      "Raven": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/raven.JPG",
      "Ruby Red": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/ruby-red.JPG",
      "Rustic Clay": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/rustic-clay.JPG",
      "Tumbleweed": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/tumbleweed.JPG",
      "Wildflower Honey": "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/exterior-door-colors/wildflower-honey.JPG",
    }
  };

  return imageMap[category]?.[value] || null;
};

// Export function to generate and open print preview
export const openPrintPreview = (formData, currentProject) => {
  const sidingData = parseSidingValue(formData.exteriorSiding);

  // Define rooms for flooring
  const rooms = [
    'Kitchen', 'Mud Room', 'Dinette', 'Dining Room', 'Great Room', 'LR/FR', 
    'Foyer', 'Study', 'Master Bedroom', 'Bedroom #2', 'Bedroom #3', 'Bedroom #4',
    '1st Floor Halls', '2nd Floor Halls', 'Other Halls', 'Laundry', 
    'Master Bath', 'Bath #2', 'Bath #3', 'Bath #4', 'Basement', 
    'Basement Bath', 'Stairs to 2nd Floor'
  ];

  // Generate flooring items for each room
  const flooringItems = rooms.map(room => {
    const fieldName = `flooring${room.replace(/[^a-zA-Z0-9]/g, '')}`;
    const value = formData[fieldName];
    const otherValue = formData[`${fieldName}Other`];
    
    // If value is 'Other', show the custom text
    const displayValue = value === 'Other' && otherValue ? otherValue : value;
    
    return { label: `${room} Flooring`, value: displayValue };
  });

  const sections = [
    {
      title: 'Exterior - Siding',
      items: [
        { label: 'Siding Type', value: sidingData.sidingType },
        { label: 'Siding Color', value: sidingData.sidingColor, colorCode: getSidingColorCode(sidingData.sidingType, sidingData.sidingColor) },
        { label: 'Trim Color', value: sidingData.trim },
        { label: 'Trim Size', value: sidingData.size },
        { label: 'Shutters', value: sidingData.shutters },
        { label: 'Fascia Color', value: sidingData.fascia, image: getImageUrl('fasciaOptions', sidingData.fascia) },
        { label: 'Soffit Color', value: sidingData.soffit, image: getImageUrl('fasciaOptions', sidingData.soffit) },
        { label: 'Drip Edge Color', value: sidingData.dripEdge, image: getImageUrl('fasciaOptions', sidingData.dripEdge) },
        { label: 'Tapered', value: formData.tapered ? 'Yes' : 'No' },
        { label: 'Stone Base', value: formData.stoneBase ? 'Yes' : 'No' },
        { label: 'Front Porch Post Color', value: formData.porchPostColor },
        { label: 'Stained Porch', value: formData.porchStained ? 'Yes' : 'No' },
        { label: 'Front Porch Pad', value: formData.porchPad },
        { label: 'Front Porch Railing', value: formData.porchRailing ? 'Yes' : 'No' },
        { label: 'Front Porch Steps', value: formData.porchSteps },
        { label: 'Front Porch Step Length', value: formData.porchStepLength },
        { label: 'Gable End', value: formData.gableEnd ? 'Yes' : 'No' },
        { label: 'Gable End Color', value: formData.gableEndColor },
        { label: 'Gable Options', value: formData.gableOptions, image: getImageUrl('gableOptions', formData.gableOptions) },
        { label: 'Corbel Options', value: formData.corbelOptions, image: getImageUrl('corbelOptions', formData.corbelOptions) },
        { label: 'Back Deck Over Hang', value: formData.deckOverhang ? 'Yes' : 'No' },
      ]
    },
    {
      title: 'Exterior - Roof',
      items: [
        { label: 'Sheathing', value: formData.sheathing },
        { label: 'Ice and H2O Shield', value: formData.iceShield },
        { label: 'Eave', value: formData.eave },
        { label: 'Felt', value: formData.felt },
        { label: 'Shingle Color', value: formData.shingleColorOptions, image: getImageUrl('shingleColorOptions', formData.shingleColorOptions) },
        { label: 'Metal Accent', value: formData.metalAccent ? 'Yes' : 'No' },
        { label: 'Standing Seam', value: formData.standingSeam ? 'Yes' : 'No' },
        { label: 'Ridge Vent', value: formData.ridgeVent ? 'Yes' : 'No' },
        { label: '4\' Shingle Over', value: formData.shingleOver ? 'Yes' : 'No' },
        { label: 'Cap Shingle Color Match Above', value: formData.capMatch ? 'Yes' : 'No' },
        { label: 'Drip Edge Color Match Aluminum', value: formData.dripEdgeMatch ? 'Yes' : 'No' },
      ]
    },
    {
      title: 'Exterior - Garage',
      items: [
        { label: 'Garage Size', value: formData.garageSize },
        { label: 'Front Garage Door Size', value: formData.frontDoorSize ? formData.frontDoorSize : null },
        { label: 'Side Garage Door Size', value: formData.sideDoorSize ? formData.sideDoorSize : null },
        { label: 'Rear Garage Door Size', value: formData.rearDoorSize ? formData.rearDoorSize : null },
        { label: 'Garage Door Style', value: formData.garageDoorStyleOptions, image: getImageUrl('garageDoorStyleOptions', formData.garageDoorStyleOptions) },
        { label: 'Exterior Service Door', value: formData.serviceDoor ? 'Yes' : 'No' },
        { label: 'Exterior Service Door Style', value: formData.serviceDoor == true ? formData.serviceDoorStyle : null },
        { label: 'Singles', value: formData.garageSingles ? 'Yes' : 'No' },
        { label: 'Bump Back', value: formData.bumpBack ? 'Yes' : 'No' },
        { label: 'Bump Back Size', value: formData.bumpBackSize ? formData.bumpBackSize : null},
        { label: 'Bump Back Style', value: formData.bumpBackStyle ? formData.bumpBackStyle : null},
        { label: 'Door Color Quality', value: formData.garageDoorQuality},
        { label: 'Windows', value: formData.garageWindows },
        { label: 'Trim Finish', value: formData.trimFinish },
        { label: 'Trim Finish Other', value: formData.trimFinishOther ?  formData.trimFinishOther : null},
        { label: 'Keypad Exterior', value: formData.keypadExterior ? 'Yes' : 'No' },
        { label: 'Aluminum Wrap', value: formData.aluminumWrap ? 'Yes' : 'No' },
        { label: 'Number of Openers', value: formData.numOpeners},
        //{ label: 'Garage Door Size', value: formData.garageDoorSize},
      ]
    },
    {
      title: 'Exterior - Brick',
      items: [
        { label: '42" Height', value: formData.brick42 ? 'Yes' : 'No' },
        { label: 'Location', value: formData.brickLocation },
        { label: 'Color', value: formData.brickColor },
        { label: 'Mortar Color', value: formData.mortarColor},
        { label: 'Style', value: formData.brickStyle },
        { label: 'Full', value: formData.brickFull ? 'Yes' : 'No'},
        { label: 'Mailbox Match', value: formData.mailboxMatch ? 'Yes' : 'No' },
      ]
    },
    {
      title: 'Exterior - Concrete',
      items: [
        { label: 'Patio Back', value: formData.patioBack ? 'Yes' : 'No' },
        { label: 'Patio Size', value: formData.patioSize ? formData.patioSize : null },
        { label: 'Garage Step', value: formData.garageStep },
        { label: 'Driveway', value: formData.driveway },
        { label: 'Other Driveway', value: formData.drivewayOther ? formData.drivewayOther : null },
        { label: '4×4 Service Door Pad', value: formData.serviceDoorPad ? 'Yes' : 'No'},
        { label: 'Options', value: formData.concreteOptions },
        { label: 'Other Options', value: formData.concreteOptionsOther ? formData.concreteOptionsOther : null },
        { label: 'Stamped', value: formData.stamped ? 'Yes' : 'No'},
        { label: 'Stamped Style', value: formData.stampedStyle ? formData.stampedStyle : null},
        { label: 'Concrete Options', value: formData.concreteMix },
      ]
    },
    {
      title: 'Exterior - Deck',
      items: [
        { label: 'Decking Material', value: formData.deckingMaterial },
        { label: 'Details', value: formData.deckDetails },
        // Conditionally show either color swatch or image based on material type
        formData.deckingMaterial === 'Wood' 
          ? { label: 'Deck Stain', value: formData.deckColorOptions, colorCode: getDeckColorCode(formData.deckColorOptions) }
          : { label: 'Composite Style', value: formData.deckColorOptions, image: getDeckImage(formData.deckColorOptions) },
        { label: 'Railing Material', value: formData.railingMaterial },
        // Show aluminum railing details if aluminum is selected
        ...(formData.railingMaterial === 'Aluminum' ? [
          { label: 'Railing Style', value: formData.aluminumRailingStyle, image: getAluminumRailingStyleImage(formData.aluminumRailingStyle) },
          { label: 'Railing Color', value: formData.aluminumRailingColor, image: getAluminumRailingColorImage(formData.aluminumRailingColor) },
        ] : []),
        { label: 'Additional Details', value: formData.deckAdditional },
      ].filter(Boolean) // Remove any null/undefined items
    },
    {
      title: 'Exterior - Landscaping',
      items: [
        { label: 'Sod', value: formData.sod ? 'Yes' : 'No' },
        { label: 'Sod Location', value: formData.sodLocation ? formData.sodLocation : null },
        { label: 'Over Seed', value: formData.overSeed ? 'Yes' : 'No' },
        { label: 'Over Seed Location', value: formData.overSeedLocation ? formData.overSeedLocation : null },
        { label: 'Sprinklers', value: formData.sprinklers ? 'Yes' : 'No' },
        { label: 'Sprinklers Location', value: formData.sprinklersLocation ? formData.sprinklersLocation : null },
      ]
    },
    {
      title: 'Interior - Brick/Stone',
      items: [
        { label: 'Fireplace', value: formData.fireplace ? 'Yes' : 'No' },
        { label: 'Stone', value: formData.fireplaceStone ? formData.fireplaceStone : null },
        { label: 'Shiplap', value: formData.fireplaceShiplap ? formData.fireplaceShiplap : null },
        { label: 'Shiplap Size', value: formData.fireplaceSize ? formData.fireplaceSize : null },
        { label: 'Box Size', value: formData.boxSize ? formData.boxSize : null },
        { label: 'Homeowner to Supply Box', value: formData.homeownerSupplyBox ? 'Yes' : 'No' },
        { label: 'Box Paint or Stain', value: formData.paintOrStain},
        { label: 'Box Paint Color', value: formData.paintOrStain == 'Paint' ? formData.paintColor : null},
        { label: 'Box Paint Color Other', value: formData.paintOrStain == 'Paint' ? formData.paintColorOther : null},
        { label: 'Box Stain Color', value: formData.paintOrStain == 'Stain' ? formData.stainColor : null, image: getStainImage(formData.stainColor) },
        { label: 'Masonry', value: formData.masonry ? formData.masonry : null },
        { label: 'Chase', value: formData.chase ? formData.chase : null },
        { label: 'Additional Options', value: formData.fireplaceOptions ? formData.fireplaceOptions : null},
        { label: 'Material', value: formData.fireplaceMaterial ? formData.fireplaceMaterial : null},
        { label: 'Grout', value: formData.fireplaceGrout ? formData.fireplaceGrout : null},
        { label: 'Additional Details', value: formData.fireplaceAdditional ? formData.fireplaceAdditional : null},
      ]
    },
    {
      title: 'Interior - Windows/Doors',
      items: [
        { label: 'Window Types', value: formData.windowTypes, image: getImageUrl('windowOptions', formData.windowTypes) },
        { label: 'Window Location', value: formData.windowLocation },
        { label: 'Grills', value: formData.grills ? 'Yes' : 'No' },
        { label: 'Patio Door', value: formData.patioDoor ? 'Yes' : 'No' },
        { label: 'Window Exterior Color', value: formData.windowExteriorColor},
        { label: 'Window Interior Color', value: formData.windowInteriorColor},
        { label: 'Interior Door Style', value: formData.doorStyle},
        { label: 'Interior Door Size', value: formData.doorSize},
        { label: 'Interior Door Options', value: formData.doorOptions, image: getImageUrl('doorOptions', formData.doorOptions) },
        { label: 'Interior Door Color', value: formData.doorColor},
        { label: 'Exterior Door Options', value: formData.outdoorDoorOptions, image: getImageUrl('outdoorDoorOptions', formData.outdoorDoorOptions) },
        { label: 'Exterior Door Glass Options', value: formData.exteriorDoorGlass, image: getImageUrl('outdoorDoorGlassOptions', formData.exteriorDoorGlass) },
        { label: 'Exterior Door Color Options', value: formData.exteriorDoorColorOptions, image: getImageUrl('exteriorDoorColorOptions', formData.exteriorDoorColorOptions) },
        { label: 'Door Hinge Options', value: formData.doorHingeOptions, image: getImageUrl('doorHingeOptions', formData.doorHingeOptions) },
        { label: 'Sidelites', value: formData.sidelites ? 'Yes' : 'No' },
        { label: 'Door Handle Style', value: formData.handleStyle},
        { label: 'Door Handle Color', value: formData.handleColor},
        { label: 'Pocket Door', value: formData.pocketDoor ? 'Yes' : 'No' },
        { label: 'Bi-Fold Door', value: formData.bifoldDoor ? 'Yes' : 'No' },
        { label: 'Barn Door', value: formData.barnDoor ? 'Yes' : 'No' },
        { label: 'Supplier', value: formData.doorSupplier},
        { label: 'Trim Details', value: formData.trimDetails},
      ]
    },
    {
      title: 'Interior - Basement',
      items: [
        { label: 'Basement Style', value: formData.basementStyle},
        { label: 'Options', value: formData.basementOptions },
        { label: 'Basement Height', value: formData.basementHeight },
        { label: 'Waterproofing', value: formData.waterproofing},
        { label: 'Drain Tile', value: formData.drainTile },
        { label: 'Egress', value: formData.egress },  
        { label: 'Soffit Box Out Around HVAC', value: formData.soffitBoxOut ? 'Yes' : 'No' },
        { label: 'Finished Basement Bath', value: formData.finishedBath ? 'Yes' : 'No' },
        { label: 'Finished Basement Bath Tub', value: formData.basementTub ? formData.basementTub : null },
        { label: 'Finished Basement Bath Sink', value: formData.basementSink ? formData.basementSink : null },
        { label: 'Finished Basement Bedroom', value: formData.finishedBed ? 'Yes' : 'No' },
        { label: 'Closet Options', value: formData.closetOptions ? formData.closetOptions : null },
      ]
    },
    {
      title: 'Interior - Stairs',
      items: [
        { label: 'Basement Stairway Finish', value: formData.basementStairFinish ? 'Yes' : 'No' },
        { label: 'Bonus Stairway Finish', value: formData.bonusStairFinish ? 'Yes' : 'No' },
        { label: 'Carpet on the Stairs', value: formData.stairCarpet ? 'Yes' : 'No' },
        { label: 'Painted', value: formData.stairPainted ? 'Yes' : 'No' },
        { label: 'Handrail', value: formData.handrail ? 'Yes' : 'No' },
        { label: 'Rails', value: formData.rails ? formData.rails : 'No' },
        { label: 'Finish', value: formData.railFinish ? formData.railFinish : 'No' },
        { label: 'Rail Paint Color', value: formData.railFinish.value === 'Stained' ? formData.railStainColor : formData.railPaintColor, colorCode: getRailColorCode(formData.railPaintColor) },
        { label: 'Handrail Bracket Color',value: formData.bracketColor },
        { label: 'Treads', value: formData.treads },
        { label: 'Flooring', value: formData.stairFlooring },  
        { label: 'Metal', value: formData.stairMetal },
        { label: 'Knull Post', value: formData.knullPost},
        { label: 'Balusters', value: formData.balusters},
        { label: '1/2 Walls with Cap', value: formData.halfWalls ? 'Yes' : 'No' },
        { label: 'Walls with Cap', value: formData.wallsCapFinish ? formData.wallsCapFinish : 'No' },
        { label: 'Additional Details', value: formData.stairAdditional},
      ]
    },
    {
      title: 'Interior - Insulation',
      items: [
        { label: 'Insulation', value: formData.insulation ? 'Yes' : 'No' },
        { label: 'Insulation Options', value: formData.insulationOptions ? formData.insulationOptions : null },
        { label: 'Ceiling Options', value: formData.ceilingOptions},
        { label: 'Batted', value: formData.batted ? 'Yes' : 'No' },
        { label: 'Foam', value: formData.foam },
        { label: 'Insulation Type', value: formData.insulationType},
        { label: 'Garage Insulation (R30)', value: formData.garageInsulation ? 'Yes' : 'No' },
        { label: 'Basement Insulation Type', value: formData.basementInsulation },  
        { label: 'Additional Options', value: formData.insulationAdditional},
      ]
    },
    {
      title: 'Interior - Mechanicals',
      items: [
        { label: 'Furnace', value: formData.furnace },
        { label: 'Air Conditioning', value: formData.airConditioning},
        { label: 'Tons', value: formData.tons },
        { label: '# of Units', value: formData.numUnits },
        { label: 'Zones', value: formData.zones},
        { label: 'Water Heater', value: formData.waterHeaterType},
        { label: 'Water Softener', value: formData.waterSoftener },  
        { label: 'Number of Sumps', value: formData.numSumps},
        { label: 'Radon', value: formData.radon ? 'Yes' : 'No'},
        { label: 'Smoke Detectors', value: formData.smokeDetectors ? 'Yes' : 'No'},
        { label: 'Generator', value: formData.generator ? 'Yes' : 'No'},
        { label: 'Micro or Hood Vent to Outside', value: formData.ventOutside ? 'Yes' : 'No'},
        { label: 'Coax', value: formData.coax ? 'Yes' : 'No'},
        { label: 'Internet Cable', value: formData.internetCable ? 'Yes' : 'No'},
        { label: 'Fan Box', value: formData.fanBox ? 'Yes' : 'No'},
        { label: 'Recessed Lighting', value: formData.recessedLighting},
        { label: 'Additional Details', value: formData.mechanicalsAdditional},
      ]
    },
    {
      title: 'Interior - Appliances',
      items: [
        { label: 'Provided By', value: formData.appliancesProvider },
      ]
    },
    {
      title: 'Interior - Flooring',
      items: [
        { label: '1st Floor Casing', value: formData.casing1st, image: getImageUrl('casingOptions', formData.casing1st) },
        { label: '1st Floor Base', value: formData.base1st, image: getImageUrl('baseOptions', formData.base1st) },
        { label: '2nd Floor Casing', value: formData.casing2nd, image: getImageUrl('casingOptions', formData.casing2nd) },
        { label: '2nd Floor Base', value: formData.casing2nd, image: getImageUrl('baseOptions', formData.base2nd) },
        { label: 'Crown & Chair Details', value: formData.trimDetails},
        ...flooringItems,
      ]
    },
    {
      title: 'Interior - Tile',
      items: [
        { label: 'Tile Floor Master Selection', value: formData.tileMaster },
        { label: 'Grout Color (Master)', value: formData.groutMaster},
        { label: 'Tile Floor Bath #2', value: formData.tileBath2 },
        { label: 'Grout Color (Bath #2)', value: formData.groutBath2 },
        { label: 'Tile Floor Bath #3', value: formData.tileBath3},
        { label: 'Grout Color (Bath #3)', value: formData.groutBath3},
        { label: 'Tile Floor Bath #4', value: formData.tileBath4 },  
        { label: 'Grout Color (Bath #4)', value: formData.groutBath4},
        { label: 'Master Shower Tile Wall', value: formData.showerWallTile},
        { label: 'Size', value: formData.showerWallSize },
        { label: 'Grout Color', value: formData.showerWallGrout},
        { label: 'Master Shower Floor Tile Selection', value: formData.showerFloorTile },
        { label: 'Drain Cover Color', value: formData.drainCoverColor },
        { label: 'Grout Color (Floor)', value: formData.showerFloorGrout},
        { label: 'Niche Tile Back', value: formData.nicheTile },
        { label: 'Niche Grout Color', value: formData.nicheGrout},
        { label: 'Schluter Strip Color', value: formData.schluterColor},
      ]
    },
    {
  title: 'Interior - Bathroom',
  items: [
    { label: 'Number of Bathrooms', value: formData.numBathrooms },
      // Dynamically generate items for each bathroom
      ...(formData.numBathrooms && parseInt(formData.numBathrooms) > 0
        ? Array.from({ length: parseInt(formData.numBathrooms) }, (_, index) => {
            const bathNum = index + 1;
            const prefix = `bathroom${bathNum}`;
            
            return [
              { label: `Bathroom #${bathNum} - Shower Base Type`, value: formData[`${prefix}_showerBaseType`] },
              { label: `Bathroom #${bathNum} - Shower/Tub Doors Location`, value: formData[`${prefix}_doorLocation`] },
              { label: `Bathroom #${bathNum} - Size`, value: formData[`${prefix}_bathSize`] },
              { label: `Bathroom #${bathNum} - Color`, value: formData[`${prefix}_bathColor`] },
              { label: `Bathroom #${bathNum} - Glass`, value: formData[`${prefix}_bathGlass`] },
              { label: `Bathroom #${bathNum} - Type`, value: formData[`${prefix}_bathType`] },
              { label: `Bathroom #${bathNum} - Stool Shape`, value: formData[`${prefix}_stoolShape`] },
              { label: `Bathroom #${bathNum} - Zero Entry`, value: formData[`${prefix}_zeroEntry`] ? 'Yes' : 'No' },
              { label: `Bathroom #${bathNum} - Zero Entry Shower Details`, value: formData[`${prefix}_zeroEntryDetails`] || null },
              { label: `Bathroom #${bathNum} - Mud Base Shower Details`, value: formData[`${prefix}_mudBaseDetails`] || null },
              { label: `Bathroom #${bathNum} - Faucet`, value: formData[`${prefix}_bathFaucet`] ? 'Yes' : 'No' },
              { label: `Bathroom #${bathNum} - Faucet Details`, value: formData[`${prefix}_faucetDetails`] },
              { label: `Bathroom #${bathNum} - Whirlpool Tub`, value: formData[`${prefix}_whirlpool`] ? 'Yes' : 'No' },
              { label: `Bathroom #${bathNum} - Whirlpool Tub Details`, value: formData[`${prefix}_whirlpoolDetails`] || null },
              { label: `Bathroom #${bathNum} - Cabinet`, value: formData[`${prefix}_bathroomCabinet`], image: getImageUrl('kitchenCabinet', formData[`${prefix}_bathroomCabinet`]) },
              { label: `Bathroom #${bathNum} - Mirror Options`, value: formData[`${prefix}_mirrorOptions`], image: getImageUrl('mirrorOptions', formData[`${prefix}_mirrorOptions`]) },
              { label: `Bathroom #${bathNum} - Additional Details`, value: formData[`${prefix}_bathroomAdditional`] },
            ];
          }).flat()
        : [])
    ]
  },
    {
      title: 'Interior - Kitchen',
      items: [
        { label: 'Kitchen Sink', value: formData.kitchenSink, image: getImageUrl('kitchenSink', formData.kitchenSink) },
        { label: 'Kitchen Faucet', value: formData.kitchenFaucet, image: getImageUrl('kitchenFaucet', formData.kitchenFaucet) },
        { label: 'Countertop Material', value: formData.countertopMaterial },
        { label: 'Countertop Color', value: formData.countertopColor },
        { label: '4" Backsplash', value: formData.backsplash4inch ? 'Yes' : 'No' },
        { label: 'Backsplash Size', value: formData.backsplashSize },
        { label: 'Kitchen Schluter Strip Color', value: formData.kitchenSchluterColor },
        { label: 'Kitchen Grout Color', value: formData.kitchenGroutColor },
        { label: 'Homeowner to Supply Cabinets', value: formData.homeownerSupply ? 'Yes' : 'No' },
        { label: 'Additional Kitchen Details', value: formData.kitchenAdditional },
      ]
    },
    {
      title: 'Interior - Features',
      items: [
        { label: 'Kitchen Door Style', value: formData.cabinetDoorStyle},
        { label: 'Door Pull Style', value: formData.doorPullStyle},
        { label: 'Pull Color', value: formData.pullColor},
        { label: 'Island to Match', value: formData.islandMatch ? 'Yes' : 'No' },
        { label: 'Island Door Pull Style', value: formData.islandPullStyle && formData.islandMatch == false ? formData.islandPullStyle : null },
        { label: 'Island Door Pull Color', value: formData.islandPullColor && formData.islandMatch == false ? formData.islandPullColor : null },
        { label: 'Homeowner to Supply Door Pulls', value: formData.homeownerSupply ? 'Yes' : 'No' },
        { label: 'Microwave in Island', value: formData.microwaveIsland ? 'Yes' : 'No' },
        { label: 'Trash in Island', value: formData.trashIsland ? 'Yes' : 'No' },
        { label: 'Kitchen Cabinets', value: formData.kitchenCabinet, image: getImageUrl('kitchenCabinet', formData.kitchenCabinet) },
        { label: 'Island Cabinets', value: formData.islandCabinet, image: getImageUrl('kitchenCabinet', formData.islandCabinet) },
        { label: 'Upper Cabinets', value: formData.upperCabinetColor, image: getImageUrl('kitchenCabinet', formData.upperCabinetColor) },
        { label: 'Back of Island Color', value: formData.islandBackColor, image: getImageUrl('kitchenCabinet', formData.islandBackColor) },
        //{ label: 'Island Back Options', value: formData.islandBackOptions },
        { label: 'Laundry Countertops and Vanities to Match Kitchen', value: formData.laundryMatch ? 'Yes' : 'No' },
        { label: 'Homeowner to Supply Countertops', value: formData.cabinetSupplier },
      ]
    },
    {
      title: 'Interior - Walls & Paint',
      items: [
        { 
          label: 'Ceiling Color', 
          value: formData.ceilingColor,
          colorCode: swPaintColors.find(c => c.name === formData.ceilingColor)?.code
        },
        { 
          label: 'Wall Paint Color', 
          value: formData.wallPaintColor,
          colorCode: swPaintColors.find(c => c.name === formData.wallPaintColor)?.code
        },
        { label: 'All Walls Same Color', value: formData.allWallsSame ? 'Yes' : 'No' },
        { 
          label: 'Accent Color', 
          value: formData.accentColor && formData.allWallsSame == false ? formData.accentColor : null,
          colorCode: swPaintColors.find(c => c.name === formData.accentColor)?.code
        },
        {label: 'Rooms and Colors', value: formData.roomColors},
        { label: 'Ceiling Fan', value: formData.ceilingFanOptions, image: getImageUrl('ceilingFanOptions', formData.ceilingFanOptions) },
        { label: 'Custom Painting', value: formData.customPainting },
      ]
    }
  ];

  // Generate HTML for items
  const generateItemHTML = (item) => {
    if (!item.value || item.value === 'No' || item.value === '') return '';

    let contentHTML = '';

    if (item.colorCode) {
      // Paint color with swatch
      contentHTML = `
        <div style="display: flex; align-items: center; gap: 10px;">
          <div style="width: 40px; height: 40px; background-color: ${item.colorCode}; border: 2px solid #ddd; border-radius: 4px;"></div>
          <div>
            <div style="color: #212529; font-size: 16px; font-weight: 500;">${item.value}</div>
          </div>
        </div>
      `;
    } else if (item.image) {
      // Item with image
      contentHTML = `
        <div>
          <img src="${item.image}" alt="${item.value}" 
            style="width: 100%; max-width: 200px; height: auto; border-radius: 6px; border: 1px solid #ddd; margin-bottom: 8px;">
          <div style="color: #212529; font-size: 16px; font-weight: 500;">${item.value}</div>
        </div>
      `;
    } else {
      // Text only
      contentHTML = `<div style="color: #212529; font-size: 16px; font-weight: 500;">${item.value}</div>`;
    }

    return `
      <div style="padding: 15px; background-color: #f8f9fa; border-radius: 8px; border: 1px solid #dee2e6; page-break-inside: avoid;">
        <div style="font-weight: 600; color: #495057; margin-bottom: 8px; font-size: 14px;">${item.label}</div>
        ${contentHTML}
      </div>
    `;
  };

  // Generate HTML for sections
  const sectionsHTML = sections.map(section => {
    const itemsHTML = section.items
      .map(item => generateItemHTML(item))
      .filter(html => html !== '')
      .join('');

    if (!itemsHTML) return '';

    return `
      <div style="margin-bottom: 40px; page-break-inside: avoid;">
        <h2 style="margin: 0 0 20px 0; color: #007bff; font-size: 22px; border-bottom: 2px solid #dee2e6; padding-bottom: 10px;">
          ${section.title}
        </h2>
        <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 20px;">
          ${itemsHTML}
        </div>
      </div>
    `;
  }).join('');

  const fullHTML = `
    <!DOCTYPE html>
    <html>
        <style>
          body {
            margin: 0;
            padding: 20px;
            font-family: Arial, sans-serif;
          }
          
          @media print {
            body {
              print-color-adjust: exact;
              -webkit-print-color-adjust: exact;
            }
            
            @page {
              margin: 0.75in;
              size: letter;
            }
            
            h1, h2 {
              page-break-after: avoid;
            }
            
            img {
              page-break-inside: avoid;
            }
          }
        </style>
      <body>
        <div style="max-width: 1200px; margin: 0 auto;">
            <title>Project Selections - ${currentProject?.name || 'N/A'}</title>
          
          ${sectionsHTML}
        </div>
      </body>
    </html>
  `;

  // Open print window
  const printWindow = window.open('', '_blank');
  
  if (!printWindow) {
    alert('Please allow pop-ups to view the print preview');
    return;
  }

  printWindow.document.write(fullHTML);
  printWindow.document.close();
  
  // Wait for images to load then trigger print
  printWindow.onload = () => {
    setTimeout(() => {
      printWindow.print();
    }, 500);
  };
};

export default openPrintPreview;